export const auth0Config = {
  domain: "liberty-connect.us.auth0.com",
  clientId: "eUW11PH9V8XlM4DpRQ1TIVIEeap3V01V",
  audience: "https://serverless.libertyconnect.nyc",
};

/*
export const auth0Config = {
  domain: "dev-obasfatuec2mfsi3.us.auth0.com",
  clientId: "hEkzkW76Y3ytvdzdwwtxzOz7YRZxmrnr",
  audience: "https://sls-authorizer",
};
*/
